import theme from '@styles/theme';
export default {
  bigBlockHeader: (bg: string) => ({
    overflow: 'hidden',
    bg,
    minHeight: ['123.733333vw', '123.733333vw', '126.041667vw', '41.6666667vw'],
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  bigBlockContent: {
    p: ['10.6666667vw', '10.6666667vw', '0 8.33333333vw', 0],
    mb: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '.headings.heading__four': {
      textAlign: 'center',
      mt: [40, 40, 64, 80],
      maxWidth: 768,
      width: '100%'
    }
  },
  imageContainer: {
    mt: ['16px', '16px', '24px', '24px', '48px'],
    width: '100%',
    maxWidth: [295, 295, 390, 390, 390, 390, '20.3125vw'],
    mx: 'auto',
    lineHeight: 0,
    '& img': {
      width: '100%',
      height: 'auto',
      maxWidth: '100%'
    }
  }
};